// 金額フォーマット
export function formatAmount(amount: number, unit: 'yen' | 'thousand' = 'yen'): string {
  const value = unit === 'thousand' ? Math.round(amount / 1000) : amount
  return value.toLocaleString('ja-JP')
}

// 日付フォーマット
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '-'
  const d = typeof date === 'string' ? new Date(date) : date
  if (!(d instanceof Date) || isNaN(d.getTime())) return '-'
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`
}

// ISO日付文字列 (YYYY-MM-DD)
export function toISODate(date: Date): string {
  if (!date || typeof date.getFullYear !== 'function') return ''
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

// 曜日（日本語）
const DAY_NAMES = ['日', '月', '火', '水', '木', '金', '土'] as const
export function getDayName(date: Date): string {
  if (!date || typeof date.getDay !== 'function') return ''
  return DAY_NAMES[date.getDay()]
}

// 日付が週末か
export function isWeekend(date: Date): boolean {
  if (!date || typeof date.getDay !== 'function') return false
  const day = date.getDay()
  return day === 0 || day === 6
}

/**
 * ISO日付 (YYYY-MM-DD) を M/D 形式にコンパクト化（同年は年省略）。
 * 異なる年の場合は YY/M/D。
 */
export function formatShortDate(iso: string): string {
  if (!iso) return ''
  const parts = iso.split('-')
  if (parts.length !== 3) return iso
  const [y, m, d] = parts
  const currentYear = String(new Date().getFullYear())
  const mm = parseInt(m)
  const dd = parseInt(d)
  if (y === currentYear) return `${mm}/${dd}`
  return `${y.slice(2)}/${mm}/${dd}`
}

/**
 * SQLite datetime ("YYYY-MM-DD HH:MM:SS" / ISO) を "M/D HH:mm" に整形。
 */
export function formatTimestamp(ts: string): string {
  if (!ts) return ''
  // "2026-04-20 10:30:00" or "2026-04-20T10:30:00Z" 両対応
  const normalized = ts.includes('T') ? ts : ts.replace(' ', 'T') + 'Z'
  const d = new Date(normalized)
  if (isNaN(d.getTime())) return ''
  const m = d.getMonth() + 1
  const day = d.getDate()
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${m}/${day} ${hh}:${mm}`
}
